export const getVisibleCalendarYears = (year: number, month: number, count = 1, showOtherDays = false, weekStart = 1) => {
    const start = new Date(year, month - 1, 1);
    const end = new Date(year, month - 1 + count, 0);
    if (showOtherDays) {
        start.setDate(start.getDate() - (start.getDay() - weekStart + 7) % 7);
        end.setDate(end.getDate() + (weekStart + 6 - end.getDay() + 7) % 7);
    }
    return Array.from({length: end.getFullYear() - start.getFullYear() + 1}, (_, index) => start.getFullYear() + index);
};
